// Polyfill for process.browser used by some libraries
if (typeof window !== 'undefined' && !window.process) {
    window.process = {
        browser: true,
        env: import.meta.env
    };
} 